/**
 * Les espaces de l'application (dossier intégral §4) et la permission qui y donne accès.
 * Un espace n'apparaît que si l'utilisateur détient au moins une des permissions ; le serveur reste seul juge.
 */
export interface Space {
  key: string;
  path: string;
  label: string;
  description: string;
  permissions: string[];
  /** Lot du backlog qui livre l'espace ; `null` = disponible. */
  plannedLot: string | null;
}

export const SPACES: Space[] = [
  {
    key: 'demandes',
    path: '/espace/demandes',
    label: 'Mes demandes',
    description:
      'Déposer et suivre une demande de bulletin, transmettre les pièces, recevoir le document autorisé.',
    permissions: ['demande.gerer_propres'],
    plannedLot: null,
  },
  {
    key: 'guichet',
    path: '/espace/guichet',
    label: 'Guichet',
    description: 'Assister le dépôt d’une demande et vérifier les pièces prévues.',
    permissions: ['guichet.assister'],
    plannedLot: null,
  },
  {
    key: 'juridictions',
    path: '/espace/juridictions',
    label: 'Juridictions',
    description: 'Préparer, contrôler et transmettre les inscriptions et les événements juridiques.',
    permissions: ['inscription.preparer', 'inscription.valider'],
    plannedLot: null,
  },
  {
    key: 'archives',
    path: '/espace/archives',
    label: 'Archives',
    description: 'Inventorier, numériser, vérifier les extractions et suivre la couverture documentaire.',
    permissions: ['archives.capturer', 'archives.verifier'],
    plannedLot: null,
  },
  {
    key: 'casier',
    path: '/espace/casier-central',
    label: 'Casier central',
    description: 'Coordonner le registre, traiter les anomalies et résoudre les conflits d’identité.',
    permissions: ['casier.controler', 'identite.resoudre'],
    plannedLot: null,
  },
  {
    key: 'delivrance',
    path: '/espace/delivrance',
    label: 'Délivrance',
    description: 'Instruire les demandes, préparer, autoriser et signer les bulletins.',
    permissions: ['bulletin.instruire', 'bulletin.signer'],
    plannedLot: null,
  },
  {
    key: 'organismes',
    path: '/espace/organismes',
    label: 'Organisme habilité',
    description: 'Déposer une demande motivée de bulletin dans un cadre autorisé.',
    permissions: ['organisme.demander'],
    plannedLot: null,
  },
  {
    key: 'finance',
    path: '/espace/finance',
    label: 'Finance',
    description: 'Contrôler les droits, paiements, timbres et rapprochements - sans contenu judiciaire.',
    permissions: ['finance.controler'],
    plannedLot: null,
  },
  {
    key: 'pilotage',
    path: '/espace/pilotage',
    label: 'Pilotage',
    description: 'Indicateurs agrégés et alertes - aucun accès nominatif.',
    permissions: ['indicateurs.consulter'],
    plannedLot: null,
  },
  {
    key: 'audit',
    path: '/espace/audit',
    label: 'Audit',
    description: 'Vérifier l’intégrité du journal et examiner les traces de son mandat.',
    permissions: ['audit.consulter'],
    plannedLot: null,
  },
  {
    key: 'habilitations',
    path: '/espace/habilitations',
    label: 'Habilitations',
    description:
      'Demander, approuver, suspendre et retirer les habilitations ; contrôler les accès d’urgence.',
    permissions: ['habilitation.demander', 'habilitation.approuver', 'habilitation.consulter'],
    plannedLot: null,
  },
  {
    key: 'technique',
    path: '/espace/technique',
    label: 'Exploitation',
    description: 'Supervision, interfaces et incidents - aucun droit métier.',
    permissions: ['technique.exploiter', 'support.intervenir'],
    plannedLot: null,
  },
];

export function visibleSpaces(permissions: readonly string[]): Space[] {
  return SPACES.filter((s) => s.permissions.some((p) => permissions.includes(p)));
}
